<div class="global-header d-flex flex-column flex-sm-row p-1 bg-white border-bottom rounded" style="height: auto;">
  <div class="col-12">
    <ul class="nav custom-nav">
      <li class="nav-item">
        <a class="nav-link" routerLink="/tiers/fournisseurs/details/:reference/detail-contenue-apercue" routerLinkActive="active" >
          Aperçu
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/tiers/fournisseurs/details/:reference/detail-contenue-relevéDuCompte" routerLinkActive="active" >
          Relevé du compte
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/tiers/fournisseurs/details/:reference/detail-contenue-document" routerLinkActive="active">
          Document
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/tiers/fournisseurs/details/:reference/detail-contenue-paimentNonAffectés" routerLinkActive="active">
          Paiement non affectés
        </a>
      </li>
    </ul>
    <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>